<template>
<div class="input-group">
	<input type="text" class="form-control fsz-xs" disabled="disabled" :placeholder="placeholder" :value="activeFile.name">
	<input type="file" ref="input" class="d-n" :multiple="multiples" :accept="accept" @change="handleChange">
	<div class="input-group-append">
		<button type="button" class="btn btn-outline-primary" @click="handleClick">{{ $Lang('选择文件') }}</button>
	</div>
</div>
</template>

<script>
	import axios from 'axios'
	import utils from '@/utils/index'
	import utilsAuth from '@/utils/auth'
	import md5 from 'md5'

	export default {
		name: 'Upload',
		props: {
			action: {
                type: String,
                required: true
            },
            headers: {
                type: Object,
                default () {
                    return {};
                }
            },
            placeholder: {
            	type: String,
                default: ''
            },
            multiples: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object
            },
            name: {
                type: String,
                default: 'file'
            },
            format: {
                type: Array,
                default () {
                    return [];
                }
            },
            accept: {
                type: String
            },
            maxSize: {
                type: Number
            },
            beforeUpload: Function,
            onSuccess: {
                type: Function,
                default () {
                    return {};
                }
            },
            onError: {
                type: Function,
                default () {
                    return {};
                }
            },
            onExceededSize: {
                type: Function,
                default () {
                    return {};
                }
            },
            onFormatError: {
                type: Function,
                default () {
                    return {};
                }
            }
		},
		methods: {
			handleClick () {
				this.$refs.input.click()
			},
			handleChange (e) {
				const files = e.target.files

				if (!files) {
					return false
				}

				this.uploadFile(files)
				this.$refs.input.value = null
			},
			uploadFile (files) {
				let postFiles = Array.prototype.slice.call(files)
                if (!this.multiples) {
                	postFiles = postFiles.slice(0, 1)
                }

                if (!postFiles.length) {
                	return false
                }

                postFiles.forEach(file => {
                	this.upload(file)
                })
			},
			upload (file) {
				this.activeFile = file

				if (!this.beforeUpload) {
					return this.post(file)
				}

				const before = this.beforeUpload(file)

				if (before && before.then) {

				} else if (before !== false) {

				} else {

				}
			},
			post (file) {
				if (!file) {
					this.onError(this.$Lang('请选择需要导入的文件'), null)
                    this.init()
					return false
				}

				// check format
				if (this.format.length) {
					const fileFormat = file.name.split('.').pop().toLocaleLowerCase()
                    const checked = this.format.some(item => item.toLocaleLowerCase() === fileFormat)
                    if (!checked) {
                        this.onFormatError(file);
                        return false
                    }
				}

				// check maxSize
                if (this.maxSize) {
                    if (file.size > this.maxSize * 1024) {
                        this.onExceededSize(file)
                        this.init()
                        return false
                    }
                }

                let formData = new FormData()
                formData.append(this.name, file)

                if (!this.objIsEmpty(this.data)) {
                	Object.keys(this.data).forEach(key => {
                		formData.append(key, this.data[key])
                	})
                }
                formData.append('timestamp', utils.dateFormat({millisecond: +new Date()}))

                const accessToken = utilsAuth.getAccessToken()
				if (accessToken) {
					formData.append('token', accessToken)
				}

                formData.append('sign', this.dataSign(formData.entries()))

                const config = {
                	headers: {
                		'Content-Type': 'multipart/form-data'
                	},
                    timeout: 0
                }
                
                axios.post(window._getApiUrl() + this.action, formData, config).then(response => {
                	if (response.data.status === 'succ') {
                		this.onSuccess(response, file)
                	} else {
                		this.onError(response.data.msg, file)
                	}

                	this.init()
                }).catch(error => {
                	this.init()
                	this.onError(error, file)
  				})
			},
            init () {
                this.activeFile = {
                    name: ''
                }
            },
			dataSign (params) {
				const data = {}
				for (var [key, value] of params) {
					if (key !== this.name) {
						data[key] = value
					}
				}

				// 数据签名
				const saltToken = utilsAuth.getSaltTokenToken()
				let dataKey = Object.keys(data)
				let md5Str = ''
				dataKey.sort()
				dataKey.forEach((item, index, array) => {
					md5Str = md5Str + item
					for (let name in data) {
						if (name === item) {
						    md5Str = md5Str + data[name]
						}
					}
				})
				md5Str = saltToken + md5Str + saltToken

				return md5(md5Str)
			}
		},
		data () {
			return {
				activeFile: {
					name: ''
				},
				tempIndex: 1,
				fileList: []
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/upload/upload.vue